import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Note } from './note.type';
import { csv } from 'd3';

@Injectable({
	providedIn: 'root',
})
export class ChildNotesService {
	constructor(private http: HttpClient) {}

	notes(childId): Observable<Note[]> {
		return this.http.get<Note[]>(`${environment.apiUrl}/note/childNotes/childId/${childId}`);
	}
	public deleteNote(id: number) {
		return this.http.post<string>(`${environment.apiUrl}/note/delete/id/${id}`, '');
	}
	public addNote(note: Note) {
		return this.http.post<any>(`${environment.apiUrl}/note/add`, note);
	}

	public updateNote(note: Note) {
		return this.http.post<any>(`${environment.apiUrl}/note/update`, note);
	}

	downloadStudentNotes(id, type = 'node'): Observable<any> {
		return this.http.get<any>(`${environment.apiUrl}/note/exportNotes/id/${id}?type=${type}`);
	}
}
